import studyAreaBoundaries from "./studyAreaBoundaries.json";
import * as turf from "@turf/turf";

const isWithinStudyArea = (lat, lng) => {
  // Basic validation to ensure lat and lng are numbers
  if (typeof lat !== "number" || typeof lng !== "number") {
    return false;
  }

  // Turns the user's latitude and longitude into a "point" that Turf.js can understand
  const point = turf.point([lng, lat]); // Note: Turf likes longitude first, then latitude

  // Checks if the point is inside any of the state boundaries. It looks at the states one by one. If the point is inside even one of them, it returns true
  return studyAreaBoundaries?.features?.some((feature) => {
    return turf.booleanPointInPolygon(point, feature);
  });
};

export default isWithinStudyArea;
